import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";
import { IMG } from "@/lib/site";

const reviews = [
  {
    name: "Sarah M.",
    suburb: "Scarborough",
    text: "Kitchen drain blocked solid on a Sunday night. Booked online in two minutes, plumber arrived 7am sharp and had it cleared within the hour. Price was exactly what the website said.",
  },
  {
    name: "Dave T.",
    suburb: "Baldivis",
    text: "Tree roots had taken over our main line. The jetting gear made short work of it and they showed me the CCTV footage after. Honest, fast, no upsell. Rare these days.",
  },
  {
    name: "Priya K.",
    suburb: "Joondalup",
    text: "Being able to see the price before booking is why I chose them. Picked my own time slot online, got a text when they were on the way. Drain cleared in 40 minutes.",
  },
  {
    name: "Mark R.",
    suburb: "Fremantle",
    text: "Second time using these guys for a blocked drain. Same deal both times — on time, upfront price, job done properly. The 5000 PSI jetter is no joke.",
  },
];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 star rating">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-[#169ed9] text-[#169ed9]" strokeWidth={2} />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="border-b-2 border-white/10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionTag number="05" label="Verified Strikes" color="#169ed9" />

        <div className="flex flex-wrap items-center gap-6 md:gap-10">
          <Reveal>
            <h2 className="max-w-3xl font-display text-4xl uppercase leading-[0.9] tracking-tight sm:text-6xl">
              Perth rates us{" "}
              <span className="text-[#169ed9]">five stars.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="max-md:flex max-md:w-full max-md:justify-center">
            <motion.img
              src={IMG.fiveStarBadge}
              alt="100+ five star Google reviews"
              className="w-32 cursor-pointer md:w-44"
              loading="lazy"
              data-testid="reviews-badge"
              animate={{ y: [0, -12, 0], rotate: [0, 4, -4, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
              whileHover={{ scale: 1.15, rotate: 0 }}
              style={{ filter: "drop-shadow(0 0 28px rgba(22,158,217,0.45))" }}
            />
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.08}>
              <figure
                data-testid={`review-card-${i}`}
                className="h-full border-2 border-white/10 bg-[#121214] p-8 transition-colors hover:border-[#169ed9]/60"
              >
                <div className="flex items-center justify-between">
                  <Stars />
                  <BadgeCheck className="h-5 w-5 text-[#169ed9]" strokeWidth={2.5} />
                </div>
                <blockquote className="mt-5 text-base leading-relaxed text-zinc-200">
                  "{r.text}"
                </blockquote>
                <figcaption className="mt-5 text-xs font-extrabold uppercase tracking-[0.2em] text-zinc-400">
                  {r.name} <span className="text-[#169ed9]">— {r.suburb}, WA</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-8">
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">
            Google Reviews — The Plumbing &amp; Electrical Co., Perth WA
          </p>
        </Reveal>
      </div>
    </section>
  );
}
